import React from 'react';

interface AuthCardLayoutProps {
  children: React.ReactNode;
}

export const AuthCardLayout: React.FC<AuthCardLayoutProps> = ({ children }) => {
  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        margin: 0,
        overflow: 'hidden',
      }}>
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: 'url("/public/images/signup_bg.jpg")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          filter: 'blur(8px)',
          zIndex: 0,
        }}></div>

      <div
        style={{
          position: 'relative',
          zIndex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: 'calc(100dvh - 135px)',
          padding: '24px 0',
        }}>
        {children}
      </div>
    </div>
  );
};
